export default __webpack_public_path__ + "static/media/site-blindado.ca6b3cbc.svg";